module.exports = function(){
    require('./canvas.service');
    require('./tracker.service');
    require('./veil.service');
    require('./helpers.service');
    require('./auth.service');
    require('./JBTranslate');
    require('./customDate');
}();




// WEBPACK FOOTER //
// ./app/services/index.js